import BulkTransactionCategoryCard from "../BulkTransactionCategoryCard";

const BulkTransactionStepCategory = ({
  bulkUploadCategoryDetails,
  handleCreateCategory,
  handleUnassignNavigate,
  bulkStatus,
  canCreateCategory,
  isLoading = false,
}) => {
  return (
    <div className="max-w-tab-width-normal mx-auto flex flex-col Qlg:flex-row Qlg:gap-gap-xl gap-gap-md">
      <div className="rounded-border-radius-md w-width-full bg-primary-card lg:max-w-[--create-box-width] h-[fit-content]">
        <BulkTransactionCategoryCard
          status={bulkStatus}
          category={bulkUploadCategoryDetails}
          header="Category"
          notes="Note: Assign the category to every account used in the file for successful processing of the file."
          activateText="To activate the inactive category click here."
          onActivate={handleUnassignNavigate}
          onCreate={handleCreateCategory}
          isCreateDisabled={!canCreateCategory}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

export default BulkTransactionStepCategory;
